// extracted by mini-css-extract-plugin
module.exports = {"versionTable":"style-module_versionTable__LIurt63D3GoP6va6154e"};